import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'

export const OutfitsHeader = observer(() => {
  return <Vertical pad={[24, 0]} wide center>
    <Typo size={24} medium upper>
      {i18n('YourOutfits')}
    </Typo>
  </Vertical>
})
